module.exports = new __parcel__URL__("meteogramme-prevision.474c8c2b.svg").toString();